import React from "react";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { I18nProvider } from "../_metronic/i18n/i18nProvider";
import { LayoutProvider, LayoutSplashScreen } from "../_metronic/layout/core";
import { MasterInit } from "../_metronic/layout/MasterInit";
import { AuthInit } from "./modules/auth";
import "react-toastify/dist/ReactToastify.css";
import { ProfileImageProvider } from "../_metronic/helpers/ProfileImageContext";
import { StyleProvider } from "../_metronic/helpers/StyleContext";
import { LogoImageProvider } from "../_metronic/helpers/LogoImageContext";
import { NavbarProvider } from "../_metronic/contexts/NavbarContext";
import { CaixaProvider } from "./components/Caixa/CaixaContext_";

const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <ToastContainer newestOnTop={true} />
      <I18nProvider>
        <CaixaProvider>
          <LogoImageProvider>
            <ProfileImageProvider>
              <StyleProvider>
                <NavbarProvider>
                  <LayoutProvider>
                    <AuthInit>
                      <Outlet />
                      <MasterInit />
                    </AuthInit>
                  </LayoutProvider>
                </NavbarProvider>
              </StyleProvider>
            </ProfileImageProvider>
          </LogoImageProvider>
        </CaixaProvider>
      </I18nProvider>
    </Suspense>
  );
};

export { App };
